import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import sanitize from 'sanitize'

function Author({ author, onAuthorPage }) {
  if (!author) return null
  const image = onAuthorPage
    ? author.avatar_urls['200']
    : author.avatar_urls['96']

  return (
    <div className={onAuthorPage ? 'o-width-limiter o-width-limiter--mid' : ''}>
      <div className={onAuthorPage ? 'c-author c-author--big' : 'c-author'}>
        <img className="c-author__avatar" src={image} alt="" />
        <p
          className="c-author__bio leading-body"
          dangerouslySetInnerHTML={{
            __html: sanitize(author.description, {}),
          }}
        />
        {!onAuthorPage && (
          <Link
            className="c-author__link text-blue-dark"
            to={'/blog/author/' + author.slug}
          >
            All posts by {author.name}
          </Link>
        )}
      </div>
    </div>
  )
}

Author.propTypes = {
  author: PropTypes.object,
  onAuthorPage: PropTypes.bool,
}

export default Author
